export const DEFAULT_DELAY = 300;
export const DEFAULT_INPUT_DELAY = 400;
export const DEFAULT_LONG_INPUT_DELAY = 1000;
